<template>
  <main :class="$style.view" v-if="page.fields">
    <div :class="$style.cover">
      <div :class="$style.image">
        <base-image v-if="coverImage" :image="coverImage" :sizes="sizes" />
      </div>
    </div>
  </main>
</template>

<script>
import PageService from '@/services/page'
import BaseImage from '@/components/base-image.vue'

export default {
  components: {
    BaseImage
  },
  data() {
    return {
      page: {}
    }
  },
  computed: {
    coverImage() {
      let images = this.page.fields.cover_images
      if (!images) return false
      let cover = images[Math.floor(Math.random() * images.length)]
      // TODO: what does this: | do?
      // items[items.length * Math.random() | 0]
      return cover
    },
    isPortrait() {
      return this.coverImage && this.coverImage.ratio < 1 ? true : false
    },
    sizes() {
      if (this.isPortrait) {
        return '(min-aspect-ratio: 3/2) 30vw, (min-aspect-ratio: 1/1) 50vw, 100vw'
      } else {
        return '(min-aspect-ratio: 3/2) 60vw, 100vw'
      }
    }
  },
  async created() {
    this.page = await PageService.get({ id: this.$route.name })
  }
}
</script>

<style lang="scss" module>
.view {
  height: 100%;
}

.cover {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding: calc(39vw + var(--gutter)) var(--gutter) var(--gutter);

  @media (min-width: $xsmall) {
    padding-top: 17rem;
  }

  @media (min-width: $small) {
    padding-top: calc(14vw + var(--gutter));
  }
}

.image {
  width: 100%;
  height: 100%;

  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
